import * as React from 'react';
import {FunctionComponent, useEffect, useState} from 'react';
import {OffErgPart, Part} from '../../../models/Part';
import {classNames} from '../../../../../components/support/classnames';
import {formatDurationMs} from '../../formatting/format_duration';

interface OwnProps {
    part: OffErgPart;
    onChange: (part: Part) => void;
}

export const DetailOffErgPart: FunctionComponent<OwnProps> = ({part, onChange}) => {
    const [durationMilliseconds, setDurationMilliseconds] = useState<number | null>(part.duration_milliseconds);

    useEffect(() => {
        //Update local state when changed externally
        if (durationMilliseconds !== part.duration_milliseconds) {
            setDurationMilliseconds(part.duration_milliseconds);
        }
    }, [part.duration_milliseconds]);
    useEffect(() => {
        //Update remote state when changed locally (but not empty!)
        if (durationMilliseconds !== part.duration_milliseconds && durationMilliseconds !== null) {
            onChange({
                ...part,
                duration_milliseconds: durationMilliseconds,
            });
        }
    }, [durationMilliseconds]);

    return (
        <div className="detail-part">
            <div className="form-group">
                <label htmlFor="instruction_text">Instruction</label>
                <input
                    type="text"
                    value={part.instruction_text}
                    className="form-control"
                    onChange={(e) => onChange({...part, instruction_text: e.target.value})}
                />
            </div>
            <div className="form-group">
                <label htmlFor="duration_milliseconds">Off erg (seconds)</label>
                <input
                    id="duration_milliseconds"
                    type="number"
                    name="duration_milliseconds"
                    className="form-control"
                    value={durationMilliseconds ? durationMilliseconds / 1000 : ''}
                    onChange={(e) => {
                        setDurationMilliseconds(e.target.value === '' ? null : parseInt(e.target.value, 10) * 1000);
                    }}
                />
            </div>

            {[20, 30, 60, 300, 600]
                .map((durationSeconds) => durationSeconds * 1000)
                .map((value) => {
                    return (
                        <div
                            key={value}
                            className={classNames('detail-part__quick-btn', {
                                'detail-part__quick-btn--highlighted': part.duration_milliseconds === value,
                            })}
                            onClick={() => onChange({...part, duration_milliseconds: value})}
                        >
                            {formatDurationMs(value)}
                        </div>
                    );
                })}
        </div>
    );
};
